export const categories = [
  { id: 1, name: "全部", slug: "all", icon: "ri-apps-line" },
  { id: 2, name: "恋爱", slug: "romance", icon: "ri-heart-line" },
  { id: 3, name: "奇幻", slug: "fantasy", icon: "ri-magic-line" },
  { id: 4, name: "动作", slug: "action", icon: "ri-fire-line" },
  { id: 5, name: "悬疑", slug: "mystery", icon: "ri-search-eye-line" },
  { id: 6, name: "搞笑", slug: "comedy", icon: "ri-emotion-laugh-line" },
  { id: 7, name: "恐怖", slug: "horror", icon: "ri-ghost-line" },
  { id: 8, name: "日常", slug: "slice-of-life", icon: "ri-sun-line" },
  { id: 9, name: "耽美", slug: "bl", icon: "ri-star-line" },
  { id: 10, name: "穿越", slug: "isekai", icon: "ri-rocket-line" },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || categories[0];
};